import React from 'react';
import './style/LoadingScreen.css'; // Import the CSS for the loading screen
import logo from './img/quanto_light-1.png';

const LoadingScreen = (overlay) => {
  return (
    <div className={`loading-screen ${overlay}`}>
      <div className="logo-container">
        <img src={logo} alt="Background Logo" className="background-logo" />
        <img src={logo} alt="Logo" className="logo" />
      </div>
    </div>
  );
};

export default LoadingScreen;
